var _circle, _circle2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolutionbottomborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1166,
    height: 54,
    viewBox: "0 0 1166 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F1F1F1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 15,
    fill: "#DBDBDB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: 26.5,
    x2: 67,
    y2: 26.5,
    stroke: "#C1C1C1"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 26.5,
    x2: 1166,
    y2: 26.5,
    stroke: "#C1C1C1",
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionbottomborder);
export default __webpack_public_path__ + "static/media/solutionbottomborder.8c29de92fe86050a5948bb0efd7ea521.svg";
export { ForwardRef as ReactComponent };